<template>
  <div>
    <x-grid
        :id="'formList'"
        :rowId="rowId"
        :pager-config="pagerConfig"
        :form-config="formConfig"
        :url="url"
        :columns="columns"
        :checkbox-config="checkboxConfig"
        :toolbar-config="toolbarConfig"
        :print-config="printConfig"
        :export-config="exportConfig"
        ref="grid"
        :cellClick="chooseRow"
        :cellDbClick="updateRow"
        @toolbar-addData="addRow"
        @toolbar-delData="delRow"
    >
      <template v-slot:[toolbarConfig.templatelSlots]>

      </template>
    </x-grid>

<!--    &lt;!&ndash; 详情页 &ndash;&gt;-->
<!--    <formModal-->
<!--        title="线索管理详情"-->
<!--        centered-->
<!--        :closable="false"-->
<!--        :footer="null"-->
<!--        :maskClosable="false"-->
<!--        :visible="editModalVisible"-->
<!--        :width="1200"-->
<!--    >-->
<!--      &lt;!&ndash; 绑定子组件事件时，如果只写方法名，则子组件$emit的参数会直接传递给方法，所以应该明确指定参数 &ndash;&gt;-->
<!--      <detailForm-->
<!--          :rowId="editRowId"-->
<!--          v-if="editModalVisible"-->
<!--          ref="detailForm"-->
<!--          @cancelled="closeEdit()"-->
<!--          @saved="closeEdit(true)"-->
<!--      >-->
<!--      </detailForm>-->
<!--    </formModal>-->

  </div>
</template>

<script>
import XGrid from "@/components/grid/XGrid";
import { GridMixin } from "@/utils/GridMixin";
import { formatter as fmt } from "@/utils/ebase-formatter";
import api from "@/services/api";
import { loadBaseCodeData } from "@/services/baseCodeSource";

console.info(fmt, loadBaseCodeData); //防止未用到报未定义错误 用到了可删除

// import {dataApi} from '@/services/comm/userManage';
// console.log(dataApi)

// import detailForm from "@/pages/web/clue/clueManage/clueManageDetail";

//弹出层组件
import { mapState } from "vuex";
import {dataApi} from "@/services/comm/ecMemberManage";
// import user from "@/services/user";

const fac = XGrid.factory;

//列表接口
const url = api.clue.REPORTALL;

//主键
const rowId = "seqId";

//列
const columns = [
  fac.makeColumnCheckboxDefault(),
  fac.makeColumnSeqDefault(),
  fac.makeColumn("clueId", "线索ID", 160, 'center'),
  fac.makeColumn("clueCreateDate", "线索创建时间", 160, 'center'),
  fac.makeColumn("clueSourceName", "线索来源", 160, 'center'),
  fac.makeColumn("regionName", "经理部", 160, 'center'),
  fac.makeColumn("dealerName", "经销商", 160, 'center'),
  fac.makeColumn("saleUserName", "销售顾问", 100, 'center'),
  fac.makeColumn("custName", "客户名称", 100, 'center'),
  fac.makeColumn("custMobile", "客户电话", 120, 'center'),
  fac.makeColumn("companyName", "客户公司", 100, 'center'),
  fac.makeColumn("custIntention", "是否有意向", 100, 'center' ,true),
  fac.makeColumn("wantStrainName", "意向品系", 100, 'center'),
  fac.makeColumn("wantBrandName", "意向品牌", 100, 'center'),
  fac.makeColumn("nextWantLevelName", "意向等级", 140, 'center'),
  fac.makeColumn("wantCount", "预购数量(台)", 100, 'center'),
  fac.makeColumn("estimateBuyDate", "预计购车日期", 160, 'center'),
  fac.makeColumn("customerAttentionName", "客户关注点", 160, 'center'),
  fac.makeColumn("dealChanceName", "成交概率", 100, 'center'),
  fac.makeColumn("reportTypeName", "跟进方式", 120, 'center'),
  fac.makeColumn("createDate", "跟进时间", 160, 'center'),
  fac.makeColumn("reportDesc", "跟进具体情况", 160, 'center'),
  fac.makeColumn("needSupportDesc", "需要支持事项", 120, 'center'),
  fac.makeColumn("nextCallonDate", "下次跟进时间", 160, 'center'),
  fac.makeColumn({
    field: "isOverdue",
    title: "是否按时跟进",
    width: 160,
    align: 'center',
    formatter:fmt.formatIsOverdue,
  }),
  // fac.makeColumn("orderNo", "订单号", 120, 'center'),
  // fac.makeColumn("succTypeName", "成交维度", 100, 'center'),
  // fac.makeColumn("succAmount", "成交额", 100, 'center'),
];

// 筛选条件
const formConfig = fac.makeFormConfig(columns, [
  { field: "custName" },
  { field: "custMobile" },
  {
    field: 'createDate',
    type: 'dateRange',
  },
  {
    field: 'nextCallonDate',
    type: 'dateRange',
  },
  { field: "clueId" },
  {
    field: "regionId",
    title: "经理部",
    type: "select",
    options: [],
  },
  {
    field: "dealerName",
    title: "经销商",
    type: "search-select",
    options: [],
  },
   {
    field: "clueSourceId",
    title: "线索来源",
    type: "select"
  },
]);

//工具栏按钮
const toolbarConfig = fac.makeToolbarConfig({
  addData: false,
  export: true,
  import: false,
  delData: false,
  templatelSlots: "toolbarBtns",
});

//可编辑表格约束
const editRules = fac.makeEditRules(columns);
const printConfig = fac.makePrintConfig(columns);
const pagerConfig = fac.makePagerConfig();
const checkboxConfig = fac.makeCheckboxConfig(columns);

async function loadBaseData() {
  let region = {
    isRegion: 1,
    isDealer: 0
  }
  let dealer = {
    isRegion: 0,
    isDealer: 1
  }
  this.regionOptions = await dataApi.selection(region);//经理部
  this.dealerOptions = await dataApi.selection(dealer);//经销商
  this.clueSourceOptions = await loadBaseCodeData('CD200004')//线索来源


   // 经理部下拉处理
  this.regionOptions = this.regionOptions.data.map(v => {
    return {
      label: v.deptName,
      value: v.deptId
    }
  })
  this.regionOptions = [{
    value: '',
    label: '全部'
  }].concat(this.regionOptions);
  this.loadSearchOption({
    regionId: this.regionOptions,
  })
  // 经销商下拉处理
  this.dealerOptions = this.dealerOptions.data.map(v => {
    return {
      label: v.deptName,
      value: v.deptName
    }
  })
  this.dealerOptions = [{
    value: '',
    label: '全部'
  }].concat(this.dealerOptions);
  this.loadSearchOption({
    dealerName: this.dealerOptions,
  })
  //线索来源
  this.clueSourceOptions = this.clueSourceOptions.map(v => {
    return {
      label: v.label,
      value: v.value
    }
  })
  this.clueSourceOptions = [{
    value: '',
    label: '全部'
  }].concat(this.clueSourceOptions);
  this.loadSearchOption({
    clueSourceId: this.clueSourceOptions,
  })
}


export default {
  mixins: [GridMixin],
  // authorize: {
  //   addRow: "ADD",
  //   updateRow: 'UPDATE',
  //   // delRow: 'DELETE',
  //   // importMethod:'IMPORT',
  //   // exportMethod:'EXPORT',
  // },
  components: {
    // detailForm,
  },
  computed: {
    ...mapState("account", { currUser: "user" }),
  },
  watch: {
    'formData.regionId'(val) { //经理部 联动经销商
      console.log("你好");
      this.formData.dealerName =null
      this.getDealerData(val)
    }
  },
  data() {
    return {
      // popConfig,
      columns,
      rowId,
      url,
      formConfig,
      toolbarConfig,
      printConfig,
      checkboxConfig,
      editRules,
      pagerConfig,
      exportUrl: api.clue.REPORT + "/exportExcel?",
      userIdList:[],
      formData: null,
    };
  },
  mounted() {
    this.formData = this.$refs.grid.$refs.xGrid.formData; //获取筛选项
  },
  methods: {
    loadBaseData,
    async createAccount(){
      let rows = this.$refs['grid'].$refs['xGrid'].getCheckboxRecords();
      if (rows.length != 1) {
        this.$message.error('请选择一条数据');
        return;
      }
      console.log(rows)
      const userId=rows[0].userId
      console.log(userId)
      await dataApi.accountNumber(userId).then((res) => {
        if (res.code===200){
          this.$message.success(res.msg);
        }else {
          this.$message.error(res.msg)
        }
        console.log(res)
        this.refresh();
      }).catch(e => {
        console.log(e);
      })
    },
    merchants(){

      let rows = this.$refs['grid'].$refs['xGrid'].getCheckboxRecords();
      console.log(rows)

      this.userIdList = rows.map((i) => {
        return i.userId;
      }).join(',')
      console.log(this.userIdList)
      this.chooseOpenPop('merchantsAuthorization',1)
    },
    closeLog(){
      this.logModalVisible = false;
    },
     /**
     * 经理部 经销商联动数据
     * @param id
     * @return {Promise<void>}
     */
    async getDealerData(id) {
      let dealer = {
        isRegion: 0,
        isDealer: 1,
        'filter.eq.parentId': id,
      }
      this.dealerOptions = await dataApi.selection(dealer);//经销商
      // 经销商下拉处理
      this.dealerOptions = this.dealerOptions.data.map(v => {
        return {
          label: v.deptName,
          value: v.deptName
        }
      })
      this.dealerOptions = [{
        value: '',
        label: '全部'
      }].concat(this.dealerOptions);
      this.loadSearchOption({
        dealerName: this.dealerOptions,
      })
    },
  },
};
</script>

<style scoped>
</style>
